import { BrandAffinityLevel } from 'modules/domains/brandAffinity';
import { MessageMedium } from 'constants/messageMediums';

export interface AffinityCampaign {
  action: CampaignAction;
  campaignId: number;
  channel: MessageMedium;
  date: string;
}

export enum CampaignAction {
  Send = 'send',
  Open = 'open',
  Click = 'click',
}

export interface DateDisplay {
  date?: string;
  relativeDate?: string;
}

export interface AffinityScore extends DateDisplay {
  label?: BrandAffinityLevel;
}
